import { range } from '@/shared/utils/misc';

const clone = (date: Date) => new Date(date.toISOString());

const day = (date: Date) => new Date(date.toISOString().substring(0, 10));

export const utcToday = () => day(new Date());

export const utcTomorrow = () => utcAddDays(utcToday(), 1);

export const utcYesterday = () => utcSubDays(utcToday(), 1);

export const utcAddMinutes = (date: Date, minutes: number) => {
  date = clone(date);
  date.setUTCMinutes(date.getUTCMinutes() + minutes);
  return date;
};

export const utcSubMinutes = (date: Date, minutes: number) => utcAddMinutes(date, minutes * -1);

export const utcAddHours = (date: Date, hours: number) => {
  date = clone(date);
  date.setUTCHours(date.getUTCHours() + hours);
  return date;
};

export const utcSubHours = (date: Date, hours: number) => utcAddHours(date, hours * -1);

export const utcAddDays = (date: Date, days: number) => {
  date = clone(date);
  date.setUTCDate(date.getUTCDate() + days);
  return date;
};

export const utcSubDays = (date: Date, days: number) => utcAddDays(date, days * -1);

export const utcAddWeeks = (date: Date, weeks: number) => utcAddDays(date, weeks * 7);

export const utcSubWeeks = (date: Date, weeks: number) => utcAddWeeks(date, weeks * -1);

export const utcAddMonths = (date: Date, months: number) => {
  const newDate = clone(date);
  newDate.setUTCMonth(date.getUTCMonth() + months);
  const newDay = newDate.getUTCDate();
  if (newDay < date.getUTCDate()) {
    newDate.setUTCDate(newDay + newDay * -1);
  }
  return newDate;
};

export const utcSubMonths = (date: Date, months: number) => utcAddMonths(date, months * -1);

export const utcAddYears = (date: Date, years: number) => utcAddMonths(date, years * 12);

export const utcSubYears = (date: Date, years: number) => utcAddYears(date, years * -1);

export const utcFirstDayOfWeek = (date: Date) => {
  date = clone(date);
  let dow = date.getUTCDay();
  dow = dow === 0 ? 7 : dow;
  if (dow !== 1) {
    date = utcSubDays(date, dow - 1);
  }
  return date;
};

export const utcLastDayOfWeek = (date: Date) => {
  date = clone(date);
  let dow = date.getUTCDay();
  dow = dow === 0 ? 7 : dow;
  if (dow !== 7) {
    date = utcAddDays(date, 7 - dow);
  }
  return date;
};

export const utcFirstDayOfMonth = (date: Date) => {
  date = clone(date);
  date.setUTCDate(1);
  return date;
};

export const utcLastDayOfMonth = (date: Date) => {
  date = utcFirstDayOfMonth(date);
  date = utcAddMonths(date, 1);
  date = utcSubDays(date, 1);
  return date;
};

export const utcFirstDayOfYear = (date: Date) => {
  date = clone(date);
  date.setUTCMonth(0);
  date.setUTCDate(1);
  return date;
};

export const utcLastDayOfYear = (date: Date) => {
  date = utcFirstDayOfYear(date);
  date = utcAddYears(date, 1);
  date = utcSubDays(date, 1);
  return date;
};

export const utcDifferenceInMinutes = (date1: Date, date2: Date) =>
  Math.floor((date1.getTime() - date2.getTime()) / (1000 * 60));

export const utcDifferenceInHours = (date1: Date, date2: Date) =>
  Math.floor((date1.getTime() - date2.getTime()) / (1000 * 60 * 60));

export const utcDifferenceInDays = (date1: Date, date2: Date) =>
  Math.floor((date1.getTime() - date2.getTime()) / (1000 * 60 * 60 * 24));

export const utcDaysLeft = (expires?: Date | null) =>
  expires ? utcDifferenceInDays(day(expires), utcToday()) : undefined;

export const utcDateRange = (from: Date, to: Date, step?: number) =>
  range(utcDifferenceInDays(to, from) + 1, step).map((i) => utcAddDays(from, i));
